module.exports = __webpack_public_path__ + "img/slider_authorization.1adbe965.png";